import MenuLinkWrapper from "../MenuLinkWrapper/MenuLinkWrapper";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import { ManageProfileIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import createAbsolutePath from "createAbsolutePath";
import { ActiveProfileQuery } from "operations";

const ManageProfileMenuLink = ({
  account,
}: Pick<ActiveProfileQuery, "account">) => {
  return (
    <MenuLinkWrapper
      href={createAbsolutePath(`/ra/profile/${account.id}`)}
      id={ManageProfileIds.ManageProfileTrigger}
      data-testid={ManageProfileIds.ManageProfileTrigger}
    >
      {messages.manageProfile}
    </MenuLinkWrapper>
  );
};

export default ManageProfileMenuLink;
